import TextfieldSimple from "../../generalComponents/TextInputField/TextfieldSimple";
import {useEffect, useReducer, useState} from "react";
import PhoneNumberFieldSimple from "../../generalComponents/TextInputField/PhoneNumberFieldSimple";
import DeleteButton from "../../UI/DeleteButton";
import Button1 from "../../UI/Button1";
import {API_ENDPOINTS} from "../../config";
import {collection, doc,  setDoc} from "firebase/firestore";
import {db} from "../../firebase/firebase";
import Dropdown from "../../generalComponents/TextInputField/Dropdown";

const initialState = {
    title: '',
    street: '',
    zip: '',
    city: '',
    country: '',
    phone: '',
    isAmbOrStat: '',
    typeOfIns: '',
    link:'',
}

const reducer = (state, action) => {
    console.log(`Calling reducer with type ${action.type} and value ${action.payload}`);
    switch (action.type){
        case 'title':
            return { ...state, title: action.payload };
        case 'street':
            return{...state, street: action.payload  }
        case 'zip':
            return{...state, zip: action.payload}
        case 'city':
            return{...state, city: action.payload}
        case 'country':
            return{...state, country: action.payload}
        case 'phone':
            return{...state, phone: action.payload}
        case 'isAmbOrStat':
            return {...state, isAmbOrStat: action.payload}
        case 'typeOfIns':
            return {...state, typeOfIns: action.payload}
        case 'link':
            return {...state, link: action.payload}
        default:
            return state;
    }
}

const AdressCustomerComponent = (props) => {
    
    const[state, dispatch] = useReducer(reducer, initialState);
    const[isPending, SetIsPending] = useState(false);
    const[allSettingsSaved, SetAllSettingsSaved] = useState(false);
    
    let { data, onDelete, key, customerID , id } = props;
    
    const handleChange = (name ,value) => {
        SetAllSettingsSaved(false);
        console.log("Calling handleChange with value: ",value );
        dispatch({type: name, payload: value});
    }
    
    useEffect(() => {
        console.log("Setting Address data with ", data);
        if (data){
            SetAllSettingsSaved(true);
            dispatch({ type:'title', payload: data.title });
            dispatch({type: 'street', payload: data.street});
            dispatch({type: 'zip', payload: data.zip});
            dispatch({type: 'city', payload: data.city});
            dispatch({type: 'country', payload: data.country});
            dispatch({type: 'phone', payload: data.phone});
            dispatch({type: 'isAmbOrStat', payload: data.isAmbOrStat});
            dispatch({type: 'typeOfIns', payload: data.typeOfIns});
            dispatch({type: 'link', payload: data.link});
        }
    }, [data]);
    
    const saveCustomerAddress = async () => {
        
        if (!customerID || customerID.trim() === '' || !customerID === undefined){
            customerID = state.title.trim();
        }
        
        console.log("State.title => " , state.title);   

        if (!customerID || customerID.trim() === ''){
            console.error("Invalid customerID. Cannot save address.");
            return;
        }

        console.log("Save customer address. CustomerID is: ", customerID);
        
        try {
            SetIsPending(true);
            // Save the address in the customer's addresses subcollection
            await setDoc(doc(collection(db, `customerAddresses/${customerID}/addresses`), state.title), state);
            console.log("Document written with path: ", `customerAddresses/${customerID}/addresses/${state.title}`);

            // Save the customer ID at the root level
            await setDoc(doc(db, `customerAddresses/${customerID}`), {customerID: id});
            console.log(`Adding the state id ${id} to the customer: `, `customerAddresses/${customerID}`);

            // Save the address in the customer IDs subcollection
            await setDoc(doc(collection(db, `customerIDs/${id}/addresses`), state.title), state);

            // Save the customer title at the root level of customer IDs
            await setDoc(doc(db, `customerIDs/${id}`), {title: state.title});
            
            SetIsPending(false);
            SetAllSettingsSaved(true);
        } catch (error) {
            console.log("Error adding document: ", error);
            SetIsPending(false);
        }
    }
    
    const typeambOrStat =[
        "stationär", "ambulant"
    ];
    
    const typeOfInstitution = [
        "Ergotherapie",
        "Physiotherapie",
        "neuropraxis",
        "Akutklinik",
        "Rehaklinik", 
        "Physio- & Ergotherapie",
        "Sonstige"
    ];
    
    return(
        <div>
            {isPending &&
                    <div>
                        <h2>
                            loading...
                        </h2>
                    </div>
            }
            {!isPending &&
            <div>
                <div className={'grid grid-cols-3 gap-1 mt-10 mb-10 '}>
                <TextfieldSimple value={state.title} label={"Location specific title"}
                                 OnChangeValue={(e) => handleChange('title', e)}/>
                <TextfieldSimple value={state.street} label={"Street"}
                                 OnChangeValue={(e) => handleChange('street', e)}></TextfieldSimple>
                <TextfieldSimple value={state.zip} label={"ZIP"}
                                 OnChangeValue={(e) => handleChange('zip', e)}></TextfieldSimple>
                <TextfieldSimple value={state.city} label={"City"}
                                 OnChangeValue={(e) => handleChange('city', e)}></TextfieldSimple>
                <TextfieldSimple value={state.country} label={"County"}
                                 OnChangeValue={(e) => handleChange('country', e)}></TextfieldSimple>
                <TextfieldSimple value={state.link} OnChangeValue={(e) => handleChange('link', e)} label={"Link"}></TextfieldSimple>
                <PhoneNumberFieldSimple value={state.phone} label={"Phone"}
                                        OnChangeValue={(e) => handleChange('phone', e)}></PhoneNumberFieldSimple>
                <Dropdown defaultValue={state.isAmbOrStat} OnChangeDropDown={(e) => handleChange('isAmbOrStat', e)} label={"stationary / ambulantory?"} menuItems={typeambOrStat}></Dropdown>
                <Dropdown defaultValue={state.typeOfIns}  OnChangeDropDown={(e) => handleChange('typeOfIns', e)} label={"type of institution"} menuItems={typeOfInstitution}></Dropdown>
                </div> 
                <div className={"flex flex-row gap-10 w-60 mb-10"}>
                    <DeleteButton
                        handleDelete={onDelete}
                        confirmTitle={`Delete address "${state.title || 'this location'}"?`}
                        confirmMessage={
                            "This will remove this location's pin from the map. " +
                            "The customer's logo will remain on the marketing site.\n\n" +
                            "This action cannot be undone."
                        }
                    />
                    <Button1 disabled={allSettingsSaved ? true : false} onclick={saveCustomerAddress} text={ allSettingsSaved ? "All Saved" : "Save"}></Button1>
                </div>
            </div>}
        </div>
    );
}

export default AdressCustomerComponent;